export default __webpack_public_path__ + "static/media/empty_state_disabled.32c1d182.svg";